module.exports = function cleanComment(data, item, list) {
    list.remove(item);
};



//////////////////
// WEBPACK FOOTER
// ./~/csso/lib/compressor/clean/Comment.js
// module id = 2513
// module chunks = 0